import type { GridColDef } from '@mui/x-data-grid-pro';
import type { Competition, CompetitionList } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';

import {
  createCashOutColumn,
  createEditColumn,
  createIsActiveColumn,
  createSportIconColumn,
} from '../../helpers/columns';
import { defaultColumnsCompetitions } from '../../helpers/table';
import useMutateData from '../../hooks/useMutateData';
import { usePagination } from '../../hooks/usePagination';
import useSort from '../../hooks/useSort';
import { createColumn } from '../../utils';
import TableTemplate from '../templates/TableTemplate';
import usePermissions from '../../hooks/usePermissions';

const CompetitionsPage = () => {
  const {
    data: competitionsData,
    updateQueryParams,
    isFetching,
    isLoading,
    changeQuery,
  } = usePagination<CompetitionList>('competitions');
  const { deleteData, updateData } = useMutateData('competitions', [QUERY_KEYS.competitions]);
  const { handleSort } = useSort(changeQuery);
  const { hasPermission } = usePermissions();
  const showCashout = hasPermission('manageCashOut');

  const columns: GridColDef[] = [
    createColumn('id', 'ID', {
      sortable: false,
    }),
    createColumn('sportName', 'Sport', {
      valueGetter: (value, row, column, apiRef) => row.sport.name,
    }),
    createSportIconColumn<Competition>(),
    createColumn('name', 'Competition Name'),
    createColumn('shortName', 'Competition Short Name'),
    createColumn('position', 'Position'),
    createIsActiveColumn<Competition>({
      updateData,
    }),
    createEditColumn<Competition>({
      deleteData,
      columnName: 'Actions',
    }),
  ];
  showCashout && columns.splice(-1, 0, createCashOutColumn<Competition>({ updateData, modalEntity: 'competition' }));

  const handleSearch = (value: string | null) => {
    changeQuery({ search: value });
  };

  return (
    <TableTemplate
      rows={competitionsData?.items || []}
      columns={columns}
      loading={isFetching || isLoading}
      rowCount={competitionsData?.count ?? 0}
      defaultVisibleColumns={defaultColumnsCompetitions}
      createItemBtnLabel='Add new competition'
      handlePaginationModelChange={updateQueryParams}
      handleSearch={handleSearch}
      handleSort={handleSort}
      changeQuery={changeQuery}
      formType='competitions'
      showExport
    />
  );
};

export default CompetitionsPage;
